<template>
<div>
  <div class="header-evento">
    <span>Ingressos</span>
  </div>
  <div>
    <div class="body">
      <input-data-calendario
        v-model="selectedDate"
        :passeio-id="passeioId"
        :initial-available-days="initialAvailableDays" />
      <div
        v-show="loadingAvailability"
        style="text-align: center; margin-top: 10px">
        <i class="fa-regular fa-hourglass" />
      </div>
      <input-horario
        v-show="!loadingAvailability && selectedDate"
        v-model="selectedAvailability"
        style="margin-top: 8px"
        :horarios="horarios"
        :selected-quantities="selectedAgeRanges"
        :primary-color="corPrimaria"
        :show-remaining-vacancies="showRemainingVacancies"
        :passeio-tipo="tipoPasseio"
        :titulo-atividade="tituloAtividade"
        :genero-titulo-atividade="generoTituloAtividade" />
    </div>
    <input-tickets
      v-show="!loadingAvailability && selectedDate"
      :key="selectedDate"
      v-model="selectedAgeRanges"
      :options="ageRanges"
      :selected-date="selectedDate"
      :primary-color="corPrimaria"
      :min="quantidadeMinVenda"
      :max="quantidadeMaxVenda"
      :nome-item="$props.nomeItem"
      :moeda="$props.moeda"
      :available="horarios"
      :selected-availability="selectedAvailability"
      :tipo-passeio="$props.tipoPasseio"
      :cobrar-taxa="cobrarTaxa"
      :taxa="taxa"
      @on-options-open-state-change="ageRangeOpened"
      @on-complience-state-change="complienceChange" />
    <div class="body">
      <input-opcionais
        v-show="nPessoas > 0 && openOpcionais"
        v-model="selectedOptionals"
        :selected-date="selectedDate"
        :max="nPessoas"
        :primary-color="corPrimaria"
        :mobile-mode="false"
        :passeio-id="passeioId"
        :moeda="$props.moeda"
        @optionals-availability-change="av => (hasOptionalsAvailable = av)" />

      <submit-button
        style="margin-top: 10px"
        :disabled="!isReady"
        :is-loading="isSubmitting"
        @click="submit" />

      <alerta-pagamento-parcial
        v-if="$props.hasPaymentPartial"
        :preco-parcial-label="$props.precoParcial"
        :porcentagem-parcial="$props.porcentagemParcial"
        :total="subtotal + totalOpcionais"
        :moeda="$props.moeda" />

      <resumo-compra
        v-if="openOpcionais"
        style="margin-top: 25px"
        :total="totalSemDesconto"
        :opcionais="totalOpcionais"
        :desconto="0"
        :moeda="$props.moeda"
        :cobrar-taxa="cobrarTaxa"
        :taxa="totalTaxa" />
    </div>
  </div>
  <div class="footer">
    <strong
      :key="'subtotal_' + subtotal"
      style="visibility: hidden; display: block"
      :style="{ visibility: isMounted ? 'visible' : 'hidden' }">
      Subtotal: {{ formatMoney(subtotal + totalOpcionais + totalTaxa) }}
    </strong>
    <span
      v-if="$props.discountByPaymentMethod"
      :key="'totalDesconto_' + totalDesconto"
      style="display: none; color: #2fb97a"
      :style="{
        display: isMounted && totalDesconto > 0 && totalDesconto < subtotal ? 'block' : 'none'
      }">
      Pagando no {{ discountPaymentMethodsLabel || 'Pix' }}: {{ formatMoney(totalDesconto + totalOpcionais + totalTaxaDesconto) }}
    </span>
  </div>
</div>
</template>

<script>
import api from '@api/store/atividades';
import axios from 'axios';

import InputDataCalendario from './components-evento/InputDataCalendarioEvento.vue';
import InputHorario from './components-evento/InputHorarioEvento.vue';
import InputOpcionais from './components-evento/InputOpcionaisEvento.vue';
import InputTickets from './components-evento/InputTicketsEvento.vue';
import SubmitButton from './components-evento/SubmitButtonEvento.vue';
import AlertaPagamentoParcial from './components/AlertaPagamentoParcial.vue';
import ResumoCompra from './components/ResumoCompra.vue';

const dateToString = function (date) {
  const mes = date.toLocaleDateString('pt-BR', { month: '2-digit' });
  const dia = date.toLocaleDateString('pt-BR', { day: '2-digit' });
  const ano = date.toLocaleDateString('pt-BR', { year: 'numeric' });
  return ano + '-' + mes + '-' + dia;
};

export default {
  name: 'CalendarioVendaEvento',
  components: {
    InputDataCalendario,
    InputHorario,
    InputTickets,
    SubmitButton,
    ResumoCompra,
    InputOpcionais,
    AlertaPagamentoParcial
  },
  props: {
    passeioId: {
      type: String,
      default: () => '0',
      required: true
    },
    corPrimaria: {
      type: String,
      default: () => '#FF0000',
      required: true
    },
    precoOriginal: {
      type: String,
      default: () => '',
      required: true
    },
    preco: {
      type: String,
      default: () => '',
      required: true
    },
    isDiscount: {
      type: Boolean,
      default: () => false,
      required: true
    },
    maxInstalments: {
      type: Number,
      default: () => 0,
      required: true
    },
    showInstalment: {
      type: Boolean,
      default: () => false,
      required: true
    },
    showRemainingVacancies: {
      type: Boolean,
      default: () => false,
      required: true
    },
    initialAvailableDays: {
      type: String,
      default: () => '[]',
      required: false
    },
    returnDays: {
      type: String,
      default: () => '[]',
      required: true
    },
    quantidadeMinVenda: {
      type: String,
      default: () => '0',
      required: true
    },
    quantidadeMaxVenda: {
      type: String,
      default: () => '9999',
      required: true
    },
    tipoPasseio: {
      type: String,
      default: () => 'fixo',
      required: true
    },
    nomeItem: {
      type: String,
      default: () => 'PESSOAS',
      required: false
    },
    moeda: {
      type: String,
      default: () => 'BRL',
      required: true
    },
    precoLabel: {
      type: String,
      default: () => '',
      required: true
    },
    tituloAtividade: {
      type: String,
      default: () => 'Atividade',
      required: false
    },
    generoTituloAtividade: {
      type: String,
      default: () => 'f',
      required: false
    },
    precoParcial: {
      type: String,
      default: () => '0',
      required: false
    },
    porcentagemParcial: {
      type: Number,
      default: () => 0,
      required: false
    },
    hasPaymentPartial: {
      type: Boolean,
      default: () => false,
      required: true
    },
    cobrarTaxa: {
      type: Boolean,
      default: () => false,
      required: true
    },
    taxa: {
      type: Number,
      default: () => 10
    },
    discountPaymentMethodsLabel: {
        type: String,
        default: '',
    },
    discountByPaymentMethod: {
        type: Boolean,
        default: () => false,
        required: true
    }
  },
  data() {
    return {
      selectedDate: null,
      selectedAgeRanges: [],
      selectedOptionals: [],
      selectedAvailability: null,
      horarios: [],
      loadingAvailability: false,
      quantityOK: false,
      isMounted: false,
      isSubmitting: false,
      hasOptionalsAvailable: false,
      ageRanges: {}
    };
  },
  computed: {
    isReady() {
      return this.selectedDate !== null && this.quantityOK && this.selectedAgeRanges.length > 0;
    },
    nPessoas() {
      let n = 0;
      this.selectedAgeRanges.forEach(ticket => (n += ticket.quantidade));
      return n;
    },
    totalSemDesconto() {
      // Soma sem desconto por período nem Pix ou Espécie
      var r = 0.0;
      this.selectedAgeRanges.forEach(faixa => {
        const precoDe =
          faixa.preco.precoDe != null ? Number(faixa.preco.precoDe) : Number(faixa.preco.preco);
        r += precoDe * faixa.quantidade;
      });
      return r;
    },
    subtotal() {
      // Soma dos valores considerando desconto por período, mas sem desconto por pagar à vista
      var r = 0.0;
      this.selectedAgeRanges.forEach(faixa => {
        r += Number(faixa.preco.preco) * faixa.quantidade;
      });
      return r;
    },
    totalTaxa() {
      if (!this.cobrarTaxa || this.taxa <= 0) {
        return 0;
      }

      let taxaTotal = 0;
      
      if (this.selectedAgeRanges && this.selectedAgeRanges.length > 0) {
        this.selectedAgeRanges.forEach(ticket => {
          if (ticket.quantidade > 0 && ticket.preco) {
            const taxaDecimal = this.taxa / 100;
            const valorLiquido = ticket.preco.preco;
            const valorBruto = valorLiquido / (1 - taxaDecimal);
            const taxaIndividual = valorBruto - valorLiquido;
            taxaTotal += this.roundMoney(taxaIndividual) * ticket.quantidade;
          }
        });
      } else {
        const taxaDecimal = this.taxa / 100;
        const valorLiquido = this.subtotal;
        const valorBruto = valorLiquido / (1 - taxaDecimal);
        const taxaCorrigida = valorBruto - valorLiquido;
        taxaTotal = this.roundMoney(taxaCorrigida);
      }
      
      return taxaTotal;
    },
    totalTaxaDesconto() {
      if (!this.cobrarTaxa || this.taxa <= 0) {
        return 0;
      }
      
      let taxaTotal = 0;
      
      if (this.selectedAgeRanges && this.selectedAgeRanges.length > 0) {
        this.selectedAgeRanges.forEach(ticket => {
          if (ticket.quantidade > 0 && ticket.preco) {
            const taxaDecimal = this.taxa / 100;
            const valorLiquido = ticket.preco.precoDesconto > 0
              ? Number(ticket.preco.precoDesconto)
              : Number(ticket.preco.preco);
            const valorBruto = valorLiquido / (1 - taxaDecimal);
            const taxaIndividual = valorBruto - valorLiquido;
            taxaTotal += this.roundMoney(taxaIndividual) * ticket.quantidade;
          }
        });
      } else {
        const taxaDecimal = this.taxa / 100;
        const valorLiquido = this.totalDesconto;
        const valorBruto = valorLiquido / (1 - taxaDecimal);
        const taxaCorrigida = valorBruto - valorLiquido;
        taxaTotal = this.roundMoney(taxaCorrigida);
      }
      
      return taxaTotal;
    },
    totalDesconto() {
      // Total já considerando desconto por período e também por pagar à vista
      var r = 0.0;
      this.selectedAgeRanges.forEach(faixa => {
        const preco =
          faixa.preco.precoDesconto > 0
            ? Number(faixa.preco.precoDesconto)
            : Number(faixa.preco.preco);
        r += preco * faixa.quantidade;
      });
      return r;
    },
    // Nota: Nenhum dos valores computados acima considera a existencia de opcionais
    totalOpcionais() {
      // Soma do valor dos opcionais
      var r = 0.0;
      this.selectedOptionals.forEach(op => {
        const preco = Number(op.preco);
        r += preco * op.quantidade;
      });
      return r;
    },
    openOpcionais() {
      return this.hasOptionalsAvailable && this.quantityOK;
    }
  },
  watch: {
    selectedAgeRange() {
      this.$nextTick(this.emitHeightUpdate);
    },
    selectedDate() {
      this.$nextTick(this.emitHeightUpdate);
      this.selectedAgeRanges = [];
      this.selectedAvailability = null;
      this.syncPricesAndAvailability();
    },
    loadingAvailability() {
      this.$nextTick(this.emitHeightUpdate);
    },
    isMounted() {
      setTimeout(this.emitHeightUpdate, 100);
    },
    totalOpcionais() {
      this.$nextTick(this.emitHeightUpdate);
    },
    selectedAvailability() {
      this.$nextTick(this.emitHeightUpdate);
    },
    openOpcionais() {
      this.$nextTick(this.emitHeightUpdate);
    }
  },
  mounted() {
    this.emitHeightUpdate();
    this.isMounted = true;
  },
  methods: {
    resetState() {
      this.selectedDate = null;
      this.selectedAgeRanges = [];
      this.selectedOptionals = [];
      this.selectedAvailability = null;
      this.horarios = [];
      this.loadingAvailability = false;
      this.quantityOK = false;
      this.isSubmitting = false;
      this.hasOptionalsAvailable = false;
      this.ageRanges = [];
    },
    emitHeightUpdate() {
      if (!window.parent) {
        return;
      }
      const calendar = document.getElementById('calendarioVendaApp');
      const event = new CustomEvent('paytCalendarHeightUpdate', { detail: { height: calendar.offsetHeight } });
      window.parent.document.dispatchEvent(event);
    },
    complienceChange(ok) {
      this.quantityOK = ok;
      this.$nextTick(this.emitHeightUpdate);
    },
    calendarOpened() {
      this.$nextTick(this.emitHeightUpdate);
    },
    ageRangeOpened() {
      this.$nextTick(this.emitHeightUpdate);
    },
    formatMoney(price) {
      let locale = 'pt-Br';

      if (this.$props.moeda === 'USD') {
        locale = 'en-US';
      }

      if (price <= 0 || price === null) {
        return Number(0.0).toLocaleString(locale, {
          style: 'currency',
          currency: this.$props.moeda
        });
      }
      return Number(price).toLocaleString(locale, {
        style: 'currency',
        currency: this.$props.moeda
      });
    },
    dataFormatada(data) {
      if (!data) {
        data = new Date();
      }
      const mes = data.toLocaleDateString('pt-BR', { month: '2-digit' });
      const dia = data.toLocaleDateString('pt-BR', { day: '2-digit' });
      const ano = data.toLocaleDateString('pt-BR', { year: 'numeric' });
      return dia + '/' + mes + '/' + ano;
    },
    async syncPricesAndAvailability() {
      this.loadingAvailability = true;
      await this.syncHorarios();
      await this.syncAgeRanges();
      this.loadingAvailability = false;
    },
    async syncHorarios() {
      if (!this.selectedDate) {
        return;
      }
      const data = dateToString(this.selectedDate);
      try {
        const r = await api.listSchedules(this.passeioId, data);
        if (typeof r !== 'object' || Array.isArray(r) || r === null) {
          this.horarios = [];
          return;
        }
        const chaves = Object.keys(r);
        const horarios = [];
        chaves.forEach(chave => {
          horarios.push(r[chave]);
        });
        this.horarios = horarios;
      } catch (err) {
        //Empty
      }
    },
    async syncAgeRanges() {
      if (!this.selectedDate) {
        return;
      }
      const data = dateToString(this.selectedDate);
      try {
        const r = await api.listPriceClassifications(this.passeioId, data);
        if (typeof r !== 'object' || Array.isArray(r) || r === null) {
          this.ageRanges = {};
          return;
        }

        this.ageRanges = r;
      } catch (err) {
        //Empty
      }
    },
    emitEventVenda(success = false, errorMsg = null, urlRedirect = null, data = null) {
      if (!window.parent) {
        return;
      }
      const event = new CustomEvent('paytVendaConcluida', {
        detail: {
          success: success,
          redirectTo: urlRedirect,
          data: data,
          error: errorMsg
        }
      });
      window.parent.document.dispatchEvent(event);
    },
    async submit() {
      if (!this.isReady || this.isSubmitting) {
        return false;
      }
      this.isSubmitting = true;

      const form = new FormData();
      form.append('type', 'evento');
      form.append('productId', this.passeioId);
      form.append('date', this.dataFormatada(this.selectedDate));

      this.selectedAgeRanges.forEach(preco => {
        form.append('quantity[' + preco.id + ']', preco.quantidade);
        if (Array.isArray(preco.disponibilidade_id)) {
          preco.disponibilidade_id.forEach((id, index) => {
            form.append(`time[${preco.id}][${index}]`, id);
          });
        } else {
          form.append('time[' + preco.id + ']', preco.disponibilidade_id);
        }
      });
      this.selectedOptionals.forEach(opt => {
        form.append('preSelectedOptionals[' + opt.id + ']', opt.quantidade);
      });
      try {
        const r = await axios.post('/adicionar-ao-carrinho', form);
        if (!r || !r.data || !r.data.redirectUrl) {
          this.emitEventVenda(false, 'O servidor não respondeu corretamente');
          return false;
        }
        this.emitEventVenda(true, null, r.data.redirectUrl, {
          idPasseio: this.passeioId,
          idDisponibilidade: this.selectedAvailability,
          data: this.selectedDate,
          tickets: JSON.parse(JSON.stringify(this.selectedAgeRanges))
        });
      } catch {
        this.emitEventVenda(false, 'Falha na conexão com o servidor');
        return false;
      } finally {
        this.isSubmitting = false;
      }

      this.resetState();
      return true;
    },
    roundMoney(value) {
      const precision = 2;
      const cents = Math.floor(value * 100);
      const formattedValue = parseFloat((value * 100).toFixed(precision));
      const formattedCents = parseFloat(cents.toFixed(precision));
            
      if (formattedValue > formattedCents) {
            return (cents + 1) / 100;
      }
      return cents / 100;
     },
  }
};
</script>
<style scoped>
.header-evento {
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 15px;
  padding-top: 15px;
  border-radius: 10px 10px 0px 0px;
  border-top: 1px solid #dfdfdf;
  border-right: 1px solid #dfdfdf;
  border-left: 1px solid #dfdfdf;
  background: #464646;
  height: 65px;
  color: #fff;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.body {
  border-bottom: 1px solid #dfdfdf;
  border-radius: 0px;
}
.payt-calendario-container .body {
  padding-right: 30px;
}
</style>
